const roundToTwoDecimals = (value: number): number => Math.round(value * 100) / 100;

const toFiniteNumber = (value: number | null | undefined): number | null => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return null;
  }
  return value;
};

export const resolveCurrentRemainingLife = (
  modelBasedRemainingLife: number | null | undefined,
  inputBasedRemainingLife: number | null | undefined,
): {
  remainingLifespanYears: number | null;
  isModelBasedRemainingLife: boolean;
  isCappedByInputBasedRemainingLife: boolean;
} => {
  const normalizedModelBasedRemainingLife = toFiniteNumber(modelBasedRemainingLife);
  const normalizedInputBasedRemainingLife = toFiniteNumber(inputBasedRemainingLife);
  if (normalizedModelBasedRemainingLife !== null) {
    const shouldCapByInput =
      normalizedInputBasedRemainingLife !== null &&
      normalizedModelBasedRemainingLife > normalizedInputBasedRemainingLife;

    return {
      remainingLifespanYears: shouldCapByInput
        ? normalizedInputBasedRemainingLife
        : normalizedModelBasedRemainingLife,
      isModelBasedRemainingLife: true,
      isCappedByInputBasedRemainingLife: shouldCapByInput,
    };
  }

  return {
    remainingLifespanYears: normalizedInputBasedRemainingLife,
    isModelBasedRemainingLife: false,
    isCappedByInputBasedRemainingLife: false,
  };
};

export const resolveEndYearRemainingLife = (params: {
  endYearRemainingLifeFromPrediction: number | null | undefined;
  currentPredictionYear: number;
  endYear: number;
  currentRemainingLife: number | null | undefined;
}): number | null => {
  const normalizedPredictionRemainingLife = toFiniteNumber(params.endYearRemainingLifeFromPrediction);
  if (normalizedPredictionRemainingLife !== null) {
    return normalizedPredictionRemainingLife;
  }

  const normalizedCurrentRemainingLife = toFiniteNumber(params.currentRemainingLife);
  if (normalizedCurrentRemainingLife === null) {
    return null;
  }

  const elapsedPredictionYears = Math.max(0, params.endYear - params.currentPredictionYear);
  return roundToTwoDecimals(normalizedCurrentRemainingLife - elapsedPredictionYears);
};
